module.exports = __webpack_public_path__ + "files/769577e88e4744bae8df19cf8db93cac.png";